const DesignIconConstants = {
  CHROME_OFFSET: 1,
  TEXT: {
    MIN_Y: -1,
    MAX_HEIGHT: 2000,
    MEDIUM_TEXT_LIMIT: 19,
    MIN_HEIGHT: 5,
    SHORT_TEXT_LIMIT: 11,
    DEFAULTS: {
      ALIGNMENT: 'center',
      EMBROIDERY_FONT_CATEGORY: 'Embroidery',
      EMBROIDERY_FONT_NAME: 'Neutra2-Medium',
      EMBROIDERY_FONT_DISPLAY: 'Neutra Medium',
      FONT_HEIGHT: 40,
      FONT_NAME: 'AvenirNextLTPro-BoldCn',
      FONT_DISPLAY: 'Avenir Bold Condensed',
      GREEK_FONT_CATEGORY: 'Greek',
      GREEK_FONT_DISPLAY_NAME: 'Block',
      GREEK_FONT_NAME: 'GRK1-Block01',
      LONG_TEXT_FONT_HEIGHT: 0.75,
      MEDIUM_TEXT_FONT_HEIGHT: 1.25,
      MIN_FONT_HEIGHT: 0.13,
      ROTATION: 0,
      SCALE_FACTOR: 1,
      LINE_HEIGHT: 2
    }
  },
  CLIPART: {
    MAX_HEIGHT: 2000,
    MIN_HEIGHT: 5,
    DEFAULTS: {
      WIDTH_PX: 100,
      HEIGHT_PX: 100,
      MIN_ART_HEIGHT: 0.005
    }
  },
  UPLOAD: {
    MAX_HEIGHT: 2000,
    MIN_HEIGHT: 5,
    DEFAULTS: {
      ICON_SIZE_INCHES: 5
    }
  },
  DOWNLOAD: {
    MAX_HEIGHT: 850,
    MAX_WIDTH: 850
  },
  TYPES: {
    clipart: 'CLIPART',
    names: 'NAMES',
    numbers: 'NUMBERS',
    text: 'TEXT',
    upload: 'UPLOAD'
  }
};

export default DesignIconConstants;
